"use strict";

!function ($) {
    var nav = $(".nav-container-burger-menu");

    if (nav) {
        var toggle = $(".nav-burger-menu");
        var drawer = $(".nav-burger-menu-items");
        var close = $(".nav-burger-menu-items .close-drawer");
        var childs = $(".has-childs");
        var search = $(".site-header__search-toggle");
        search.on("click", function (e) {
            e.preventDefault();
            nav.removeClass('is-active');
        });
        toggle.on("click", function (e) {
            e.preventDefault();
            nav.toggleClass('is-active');

            slate.a11y.trapFocus({
                container: drawer[0],
                namespace: 'burger-menu',
            });
        });
        drawer.on('keydown', function (e) {
            if (e.key === 'Escape') {
                nav.removeClass('is-active');
                toggle.focus();
            }

            const activeItem = document.activeElement;
            const isResultItem = activeItem.classList.contains('search-result-item');

            if (e.key === 'ArrowDown' && isResultItem) {
                e.preventDefault();
                const parent = activeItem.parentElement;

                if (!parent.nextElementSibling) {
                    return;
                }

                const nextElement = parent.nextElementSibling.querySelector('.search-result-item');

                if (!nextElement || !isResultItem) return;

                nextElement.focus();
            }

            if (e.key === 'ArrowUp') {
                e.preventDefault();
                const parent = activeItem.parentElement;

                if (!parent.previousElementSibling) return;

                const prevElement = parent.previousElementSibling.querySelector('.search-result-item');

                if (!prevElement || !isResultItem) return;

                prevElement.focus();
            }
        });
        close.on("click", function (e) {
            e.preventDefault();
            nav.toggleClass('is-active');

            slate.a11y.removeTrapFocus({
                container: drawer[0],
                namespace: 'burger-menu',
            });

            toggle.focus();
        });
        childs.on("click", function (e) {
            e.preventDefault();
            $('.nav-items .nav-item').removeClass('site-nav__link--active');
            $(this).addClass('site-nav__link--active');
            $('.child-menu').removeClass('active').fadeOut();
            $(this).parent().find('.child-menu').addClass('active').fadeIn();
        });
    }

    if ($("#SearchNoResults").length) {
        $('.sch-tab-for-slider').click(function () {
            $('.sch-product-slider').each(function () {
                $(this).slick('refresh');
            });
        });

        $('.sch-product-slider').each(function () {
            const $slider = jQ(this);

             $slider.slick({
                dots: true,
                arrows: true,
                infinite: true,
                slidesToShow: 3,
                slidesToScroll: 1,
                useTransform: true,
                cssEase: 'linear',
                touchThreshold: 1000,
                variableWidth: true,
                responsive: [
                    {
                        breakpoint: 1025,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            variableWidth: true,
                        },
                    },
                    {
                        breakpoint: 769,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            variableWidth: true,
                        },
                    },
                ],
            });
        });

        if ($('.product-info-tabs').length) {
            $('.products_tabgroup > div').hide();
            $('.products_tabgroup > div:first-of-type').show();
            $('.product-info-tabs a').click(function (e) {
                e.preventDefault();
                var $this = $(this),
                    products_tabgroup = '#' + $this.parents('.product-info-tabs').data('tabgroup'),
                    others = $this.closest('li').siblings().children('a'),
                    target = $this.attr('href');
                others.removeClass('active');
                $this.addClass('active');
                $(products_tabgroup).children('div').hide();
                $(target).show();
            });
        }
    }
}(jQuery);